var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.333 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Documentation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-help",
    "data-name": "Icon ionic-md-help",
    d: "M42.542,84.5H28.792V70.958h13.75Zm-.208-20.417H29c0-21.042,20-19.812,20-33.125A13.266,13.266,0,0,0,35.667,17.75,13.61,13.61,0,0,0,22.333,31.167H9a26.667,26.667,0,0,1,53.333-.208C62.333,47.6,42.333,49.5,42.333,64.083Z",
    transform: "translate(-9 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.9d81e15100ac366ab44562a2b6c84ac2.svg";
export { ForwardRef as ReactComponent };